import React from 'react';
import { AtlassianNavigationStart } from '@atlassian/jira-atlassian-navigation/src/controllers/atlassian-navigation-start/index.tsx';
import { useNav4Theme } from '@atlassian/jira-atlassian-navigation/src/controllers/theme/main.tsx';
import { JiraAtlassianNavigationSkeleton as TopNavigationSkeleton } from '@atlassian/jira-atlassian-navigation/src/ui/skeleton/index.tsx';
import { PAGE_LAYOUT_OFFSET_TOP } from '@atlassian/jira-common-constants/src/page-layout.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { useTopNavState } from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/top-nav-controller/index.tsx';
import { TopNavigation } from '@atlassian/jira-navigation-system/src/index.tsx';
import { PlaceholderNew } from '@atlassian/jira-placeholder/src/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { AsyncAtlassianNavigation } from './async-atlassian-navigation/index.tsx';

const LegacyPageNavigationStyles = () => (
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
	<style
		// eslint-disable-next-line react/no-danger
		dangerouslySetInnerHTML={{
			__html: `
                    #page-body { width: 100vw; max-width: 100%; }
                    #cloneissueprogressform { margin-top: 24px; }
                    [data-testid="Content"] {margin-top: calc(${PAGE_LAYOUT_OFFSET_TOP})!important;}
                    #view-projects-content { margin-top: calc(-1 * ${PAGE_LAYOUT_OFFSET_TOP}); } /* admin project dir hack */
                `,
		}}
	/>
);

/**
 * This test ID is used in pollinator tests. Do not change lightly.
 * It's only added once the component is rendered client-side.
 */
const TEST_ID = 'page-layout.top-nav';

/**
 * Implements a responsive top navigation bar that renders based on application state.
 * It ensures seamless navigation experience across different sections of the application
 * while handling errors gracefully and tracking performance.
 */
export function TopNav() {
	const { shouldRender } = useTopNavState();

	const theme = useNav4Theme();

	if (!shouldRender) {
		return null;
	}

	return (
		<UFOSegment name="nav4.topNav">
			<LegacyPageNavigationStyles />
			<TopNavigation testId={TEST_ID} theme={theme}>
				{!__SERVER__ && <AtlassianNavigationStart />}
				<JSErrorBoundary
					id="navigation.atlassian-navigation"
					packageName="jiraPageContainerV2"
					fallback="flag"
				>
					<PlaceholderNew name="top_navigation_skeleton" fallback={<TopNavigationSkeleton />}>
						<AsyncAtlassianNavigation />
					</PlaceholderNew>
				</JSErrorBoundary>
			</TopNavigation>
		</UFOSegment>
	);
}
